import { cover } from '../utility/constant/helper.constant'
import { useMontageUpdate } from '../context/montage.context'
import {
  useSelectedNumberByVariableKey,
  useSelectedValueAttributeByKey,
  useSelectedValueByVariableKey,
} from '@k3/core'
import {
  TAttachment,
  TDitchForm,
  TDockTile,
  TEnginePosition,
  TEngineType,
  TFabricColor,
  TGlassDensity,
  TLedSpots,
  TLedSpotsSet,
  TFacadae,
  TMarqueeType,
  TSidewallFront,
  TSidewallLeft,
  TSidewallRight,
  TSupportForm,
  TTerraceColor,
  TTerraceDepth,
  TTerraceModel,
  TTerraceWidth,
  TTyp,
  TPoles,
} from '../utility/type/terraceCover.type'
import { useEffect } from 'react'

export const useInterface = () => {
  // Measure
  const model =
    (useSelectedValueByVariableKey('model')?.label as TTerraceModel) ??
    cover.terraceCover.model

  const height =
    useSelectedNumberByVariableKey('height') ?? cover.terraceCover.height

  const width =
    useSelectedNumberByVariableKey('width') ?? cover.terraceCover.width

  const depth =
    useSelectedNumberByVariableKey('depth') ?? cover.terraceCover.depth

  const angle = useSelectedNumberByVariableKey('angle') ?? cover.bar.angle

  const attachment =
    (useSelectedValueByVariableKey('attachment')?.label as TAttachment) ??
    cover.terraceCover.attachment

  const polesNumberString =
    useSelectedValueByVariableKey('polesNumber') ?? cover.terraceCover.poles

  const polesNumber: number = +polesNumberString;

  // Typ
  const typ =
    (useSelectedValueByVariableKey('typ')?.label as TTyp) ??
    cover.terraceCover.typ
  // TODO useSelectedValueAttributeByKey hook not work !!!!!!
  // const attrs =  (useSelectedValueAttributeByKey('typ', 'breite')?.value as any) ?? 0

  const attr =
    useSelectedValueByVariableKey('typ')?.attrs?.filter((a) => a.value) ?? []
  const attrWidth = attr?.length > 0 ? attr[0]?.value : 8
  const attrDepth = attr?.length > 1 ? attr[1]?.value : 8

  // Roof
  const color =
    (useSelectedValueByVariableKey('color')?.value as TTerraceColor) ??
    cover.bar.color

  const ditchForm =
    (useSelectedValueByVariableKey('ditchForm')?.label as TDitchForm) ??
    cover.terraceCover.ditchForm

  const supportForm =
    (useSelectedValueByVariableKey('supportForm')?.label as TSupportForm) ??
    cover.terraceCover.supportForm

  const glassDensity =
    (useSelectedValueByVariableKey('glassDensity')?.label as TGlassDensity) ??
    cover.terraceCover.safetyGlassDensity

  const dockTile =
    (useSelectedValueByVariableKey('dockTile')?.label as TDockTile) ??
    cover.terraceCover.dockTile

  // Marquee
  const marquee =
    (useSelectedValueByVariableKey('marquee')?.label as TMarqueeType) ??
    cover.terraceCover.marquee

  const engine =
    (useSelectedValueByVariableKey('engine')?.label as TEngineType) ??
    cover.terraceCover.engine

  const enginePosition =
    (useSelectedValueByVariableKey('enginePosition')
      ?.label as TEnginePosition) ?? cover.terraceCover.enginePosition

  const fabricColor =
    (useSelectedValueByVariableKey('fabricColor')?.value as TFabricColor) ??
    cover.terraceCover.fabricColor

  // Sidewall
  const sidewallRight =
    (useSelectedValueByVariableKey('sidewallRight')?.label as TSidewallRight) ??
    cover.terraceCover.sidewallRight

  const sidewallLeft =
    (useSelectedValueByVariableKey('sidewallLeft')?.label as TSidewallLeft) ??
    cover.terraceCover.sidewallLeft

  const sidewallFront =
    (useSelectedValueByVariableKey('sidewallFront')?.label as TSidewallFront) ??
    cover.terraceCover.sidewallFront

  // LedSpots
  const ledSpots =
    (useSelectedValueByVariableKey('ledSpots')?.label as TLedSpots) ??
    cover.terraceCover.ledSpots

  const ledSpotsSet =
    (useSelectedValueByVariableKey('ledSpotsSet')?.label as TLedSpotsSet) ??
    cover.terraceCover.ledSpotsSet

  const facade =
    (useSelectedValueByVariableKey('facade')?.label as TFacadae) ??
    cover.environment.facade

  const {
    onHandleModel,
    onHandleHeight,
    onHandleWidth,
    onHandleDepth,
    onHandleAngle,
    onHandleAttachment,
    onHandleTyp,
    onHandlePoles,
    onHandleDepthAndWidth,
    onHandleTerraceColor,
    onHandleDitchForm,
    onHandleSupportForm,
    onHandleSafetyGlass,
    onHandleDockTile,
    onHandleMarquee,
    onHandleEngine,
    onHandleEnginePosition,
    onHandleFabric,
    onHandleSidewallRight,
    onHandleSidewallLeft,
    onHandleSidewallFront,
    onHandleLedSpots,
    onHandleLedSpotsSet,
    onHandleFacade,
  } = useMontageUpdate()

  useEffect(() => {
    // Measure
    onHandleModel(model)
    onHandleHeight(height!)
    onHandleWidth(width as TTerraceWidth)
    onHandleDepth(depth as TTerraceDepth)
    onHandleAngle(angle)
    onHandleAttachment(attachment)
    onHandlePoles(polesNumber as TPoles)

    // Typ
    onHandleTyp(typ)
    onHandleDepthAndWidth(attrWidth, attrDepth)

    // Roof
    onHandleTerraceColor(color)
    onHandleDitchForm(ditchForm)
    onHandleSupportForm(supportForm)
    onHandleSafetyGlass(glassDensity)
    onHandleDockTile(dockTile)

    // Marquee
    onHandleMarquee(marquee)
    onHandleEngine(engine)
    onHandleEnginePosition(enginePosition)
    onHandleFabric(fabricColor)

    // Sidewall
    onHandleSidewallRight(sidewallRight)
    onHandleSidewallLeft(sidewallLeft)
    onHandleSidewallFront(sidewallFront)

    // Led-Spots
    onHandleLedSpots(ledSpots)
    onHandleLedSpotsSet(ledSpotsSet)

    // Environment
    onHandleFacade(facade)
  }, [
    angle,
    attachment,
    typ,
    color,
    depth,
    ditchForm,
    dockTile,
    engine,
    enginePosition,
    fabricColor,
    glassDensity,
    height,
    ledSpots,
    ledSpotsSet,
    marquee,
    model,
    facade,
    onHandleAngle,
    onHandleAttachment,
    onHandleTyp,
    onHandleDepthAndWidth,
    onHandleDepth,
    onHandleDitchForm,
    onHandleDockTile,
    onHandleEngine,
    onHandleEnginePosition,
    onHandleFabric,
    onHandleHeight,
    onHandleLedSpots,
    onHandleLedSpotsSet,
    onHandleMarquee,
    onHandleModel,
    onHandlePoles,
    onHandleSafetyGlass,
    onHandleSidewallFront,
    onHandleSidewallLeft,
    onHandleSidewallRight,
    onHandleSupportForm,
    onHandleTerraceColor,
    onHandleWidth,
    onHandleFacade,
    sidewallFront,
    sidewallLeft,
    sidewallRight,
    supportForm,
    width,
    polesNumber,
    attr,
  ])
}
